/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'transcript': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M4.291 7A6.751 6.751 0 0111 1h2a6.751 6.751 0 016.709 6H20a3.75 3.75 0 110 7.5h-1a.75.75 0 01-.75-.75v-6c0-2.9-2.35-5.25-5.25-5.25h-2a5.25 5.25 0 00-5.25 5.25v6a.75.75 0 01-.75.75H4A3.75 3.75 0 114 7h.291zM4.25 8.5H4A2.25 2.25 0 004 13h.25V8.5zm15.5 4.5H20a2.25 2.25 0 000-4.5h-.25V13zM8.25 23a.75.75 0 01.75-.75h6a.75.75 0 010 1.5H9a.75.75 0 01-.75-.75zM9 5.25A1.75 1.75 0 007.25 7v12c0 .966.784 1.75 1.75 1.75h6A1.75 1.75 0 0016.75 19V7A1.75 1.75 0 0015 5.25H9zM8.75 7A.25.25 0 019 6.75h6a.25.25 0 01.25.25v12a.25.25 0 01-.25.25H9a.25.25 0 01-.25-.25V7z" _fill="#000"/>'
  }
})
